import { useQuery } from '@tanstack/react-query';
import { issueDetailApi, IssueFormSummary } from '../api/issueDetailApi';

export const useIssueForms = (issueId?: string) => {
  const { data: forms = [], isLoading, error } = useQuery<IssueFormSummary[]>({
    queryKey: ['issue-forms', issueId],
    queryFn: () => issueDetailApi.fetchIssueForms(issueId as string),
    enabled: !!issueId,
  });

  return { forms, isLoading, error: error as Error | null };
};
